import React from 'react';
import {
  GDSStatus,
  ParagraphText,
  StatusBanner,
} from '@leagueplatform/genesis-core';
import type {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';

export type GenericStatusBannerNodeProperties = {
  body?: string;
  heading?: string;
  status?: string;
};

export type GenericStatusBannerNode = MasonryEngineNode<
  'hm_pre_effective_banner',
  GenericStatusBannerNodeProperties,
  {},
  {}
>;

type GenericStatusBannerRendererProps =
  MasonryEngineNodeRendererProps<GenericStatusBannerNode>;

export const GenericStatusBanner = ({
  heading,
  body,
  status,
}: GenericStatusBannerRendererProps) => (
  <StatusBanner title={heading} status={status as GDSStatus}>
    <ParagraphText size="sm">{body}</ParagraphText>
  </StatusBanner>
);
